import React from "react";
import useDebugInformation from "../../../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";
import CallMeBackDialog from "./CallMeBackDialog";
import Table from "./Table";

const name = "CallMeBack";

// create react component with typescript named CallMeBacks and export as default using memo

interface Props {
    parent: string;
}

const CallMeBacks: React.FC<Props> = ({ parent }) => {
    const callMeBacksModal = useAppSelector(({ ui }) => ui.CallMeBacksModal);
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent })

    return (<>
        {callMeBacksModal && <CallMeBackDialog parent={debugName} />}
        <Table />
    </>
    )
}

CallMeBacks.displayName = name;

export default React.memo(CallMeBacks);